import React from 'react';
import { kebabCase } from 'lodash';
import { useField } from 'formik';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';
import { FieldLabel, FieldMessage } from './FieldChrome';
import useFieldMessage from './useFieldMessage';
import './disabledFields.css';

type FormikInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'value' | 'type' | 'size'
> & {
  name: string;
  id?: string;
  label?: React.ReactNode;
  value?: string | number | null;
  errorMessage?: string | null;
};

const FormikInput = ({
  name,
  id,
  label,
  value,
  onChange,
  errorMessage,
  ...rest
}: FormikInputProps) => {
  const [field] = useField(name);
  const { hasError, message } = useFieldMessage(name, errorMessage);
  const inputId = id ?? kebabCase(name);

  return (
    <div className="h-8">
      {label && <FieldLabel htmlFor={inputId}>{label}</FieldLabel>}
      <Input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
        id={inputId}
        className="cwf-kit-field"
        name={name}
        value={value ?? field.value ?? ''}
        onChange={onChange ?? field.onChange}
        onBlur={field.onBlur}
        status={hasError ? 'error' : undefined}
      />
      <FieldMessage message={message} />
    </div>
  );
};

export default FormikInput;
